import { css } from '@emotion/css';

export const containerStyles = css`
  height: 60rem;
`;

export const bannerOverlayStyles = css`
  background: rgba(0, 0, 0, 0.3);
`;

export const repositionLabelStyles = css`
  top: calc(50% - 1.6rem);
  left: calc(50% - 9.6rem);
`;

export const imageStyles = (yOffsetPercent: number = 50) => css`
  object-position: 50% ${yOffsetPercent}%;
`;

export const titleStyles = css`
  textarea {
    padding-inline-end: 0;
  }
`;

export const mainContentStyles = css`
  max-width: 70rem;
`;
